import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { AreaTypeService } from '../proxy/planning/controllers/area-type.service';

FieldBuilder.setNamespace('Planning');

export const LOCATIONTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.LocationType.Name')
    .required()
    .minLength(1)
    .maxLength(40)
    .build(),
  FieldBuilder
    .text('code', 'Entity.LocationType.Code')
    .required()
    .minLength(2)
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isCostReceiver', 'Entity.LocationType.IsCostReceiver')
    .build(),
  FieldBuilder
    .checkbox('isOriginDefault', 'Entity.LocationType.IsOriginDefault')
    .build(),
  FieldBuilder
    .checkbox('isDestinationDefault', 'Entity.LocationType.IsDestinationDefault')
    .build(),
  FieldBuilder
    .foreignKey('areaTypeId', 'Entity.AreaType', AreaTypeService)
    .required()
    .displayFromNested('areaType.name')
    .sortBy('areaType.name')
    .build(),
];

export const LOCATIONTYPE_CONFIG = {
  entityName: 'LocationType',
  localizationKey: 'Planning::Entity.LocationType',
  fields: LOCATIONTYPE_FIELDS,
  permission: 'ControllingStructural.LocationTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Structural + MENU_NAME_SUFFIX,
};
